/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 *
 * @emails oncall+draft_js
 */
'use strict';

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(
        Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        })
      );
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var ContentBlock = require('draft-js/lib/ContentBlock');

var ContentBlockNode = require('draft-js/lib/ContentBlockNode');

var convertFromHTMLToContentBlocks = require('draft-js/lib/convertFromHTMLToContentBlocks');

var generateRandomKey = require('draft-js/lib/generateRandomKey');

var getSafeBodyFromHTML = require('draft-js/lib/getSafeBodyFromHTML');
var convertFromRawToDraftState = require('draft-js/lib/convertFromRawToDraftState');

var gkx = require('draft-js/lib/gkx');

var Immutable = require('immutable');

var sanitizeDraftText = require('draft-js/lib/sanitizeDraftText');

var List = Immutable.List,
  Repeat = Immutable.Repeat;
var experimentalTreeDataSupport = gkx('draft_tree_data_support');
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
var DraftPasteProcessor = {
  processHTML: function processHTML(html, blockRenderMap) {
    const body = getSafeBodyFromHTML(html);
    const fragmentElt = body && body.querySelector('[data-editor-content]');
    const fragmentAttr = (fragmentElt && fragmentElt.getAttribute('data-editor-content')) || null;
    // Handle the paste without converting the HTML if it comes from another Draft.js editor.
    if (fragmentAttr) {
      let rawContent;

      try {
        // If JSON parsing fails, handle the paste as normal HTML.
        rawContent = JSON.parse(fragmentAttr);
      } catch (error) {}

      if (rawContent) {
        const content = convertFromRawToDraftState(rawContent);
        return {
          contentBlocks: content.getBlocksAsArray(),
          entityMap: content.getEntityMap(),
        };
      }
    }
    return convertFromHTMLToContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
  },
  processText: function processText(textBlocks, character, type) {
    return textBlocks.reduce(function (acc, textLine, index) {
      textLine = sanitizeDraftText(textLine);
      var key = generateRandomKey();
      var blockNodeConfig = {
        key: key,
        type: type,
        text: textLine,
        characterList: List(Repeat(character, textLine.length)),
      }; // next block updates previous block

      if (experimentalTreeDataSupport && index !== 0) {
        var prevSiblingIndex = index - 1; // update previous block

        var previousBlock = (acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
          nextSibling: key,
        }));
        blockNodeConfig = _objectSpread({}, blockNodeConfig, {
          prevSibling: previousBlock.getKey(),
        });
      }

      acc.push(new ContentBlockRecord(blockNodeConfig));
      return acc;
    }, []);
  },
};
module.exports = DraftPasteProcessor;
